import './index.scss'
import classNames from 'classnames'
import {useSelector} from 'react-redux'
import CustomSelect from '../../core/customSelect'
import {useTranslation} from 'react-i18next'
import {languageIcons} from '../../../utils/locations'
import {startTransition, useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import {stripLangPrefix} from '../../../utils/navigation'
import localStorageKeys from '../../../utils/localStorageKeys'
import {useNamespaceTranslations} from '../../../utils/hooks/useNamespacesTranslations'
import {envConfig} from '../../../utils/env'

const Footer = () => {
    const data = useNamespaceTranslations('footer')
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const {i18n} = useTranslation()
    const navigate = useNavigate()
    const {locale, siteUrl} = envConfig
    const lang = localStorage.getItem(localStorageKeys.LANGUAGE)

    const setLangtoLocalStorage = value => localStorage.setItem(localStorageKeys.LANGUAGE, value)

    const getCurrentYear = () => {
        return new Date().getFullYear()
    }
    const linkBuilder = url => {
        return siteUrl + url
    }
    const generateFooterMenu = () => {
        return (
            <ul className='footer-left'>
                {data.menu.map((item, index) => (
                    <li key={index}><a target="_blank" href={linkBuilder(item.url)}>{item.name}</a></li>
                ))}
            </ul>
        )
    }

    const handleChange = (lang) => {
        startTransition(() => {
            i18n.changeLanguage(lang.value)
        })
        setLangtoLocalStorage(lang.value)
        navigate(lang.value !== locale ?
            `/${lang.value}${stripLangPrefix(location.pathname)}${location?.hash || ''}` :
            `${stripLangPrefix(location.pathname)}${location?.hash || ''}`, {replace: false})
        document.documentElement.lang = lang.value
    }

    useEffect(() => {
        if (!lang) setLangtoLocalStorage(locale)
    }, [])

    const languageOptions = Object.values(data.language_options).map(option => ({...option,
        icon: languageIcons[option.value]}))

    return (
        <footer className={classNames('footer', {
            dark: isDarkMode
        })}>
            {generateFooterMenu()}
            <div className='footer-right'>

                <CustomSelect
                    onChange={(_, value) => handleChange(value)}
                    value={languageOptions?.find(option => option.value === lang)}
                    name='language'
                    className='select-language'
                    options={languageOptions}
                    menuPlacement='top'
                />
                <p>© {getCurrentYear()} Pinghome</p>
            </div>
        </footer>
    )
}

export default Footer
